import React, { Suspense, lazy, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SearchInput from "../SearchPage/SearchInput";
import TrendingSearch from "./TrendingSearch";
import video from "../../assets/home/banner.mp4";
import useAuth from "../../hooks/useAuth";
import { hasActiveSubscription } from "../../utils/subscriptionUtils";

const SignIn = lazy(() => import("../SignIn/SignIn"));
const SignUp = lazy(() => import("../SignUp/SignUp"));
const HERO_POSTER = `${process.env.PUBLIC_URL || ""}/images/hero-poster.webp`;

const Banner = () => {
  const { auth } = useAuth();
  const isSubscribed = hasActiveSubscription(auth?.subscription);

  const [showSignInModal, setShowSignInModal] = useState(false);
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  useEffect(() => {
    const enableVideo = () => setShowVideo(true);
    window.addEventListener("pointerdown", enableVideo, {
      once: true,
      passive: true,
    });
    window.addEventListener("keydown", enableVideo, { once: true });
    window.addEventListener("scroll", enableVideo, {
      once: true,
      passive: true,
    });

    return () => {
      window.removeEventListener("pointerdown", enableVideo);
      window.removeEventListener("keydown", enableVideo);
      window.removeEventListener("scroll", enableVideo);
    };
  }, []);

  return (
    <section
      className="relative p-0 md:rounded-3xl md:py-2 z-10"
      aria-label="Shotkut hero banner"
    >
      <div className="hero-banner-media relative md:rounded-3xl rounded-2xl">
        <img
          src={HERO_POSTER}
          alt=""
          width="1920"
          height="1080"
          fetchPriority="high"
          loading="eager"
          decoding="sync"
          className={`hero-banner-visual l-shaped-video object-cover md:rounded-3xl w-full ${isVideoPlaying ? "md:invisible" : "visible"
            }`}
          aria-hidden="true"
        />

        {showVideo && (
          <video
            autoPlay
            loop
            muted
            playsInline
            poster={HERO_POSTER}
            preload="none"
            onPlaying={() => setIsVideoPlaying(true)}
            onEmptied={() => setIsVideoPlaying(false)}
            className="hero-banner-visual l-shaped-video absolute inset-0 z-[1] hidden object-cover md:block md:rounded-3xl w-full"
            aria-hidden="true"
            title="Indian stock footage showreel"
          >
            <source src={video} type="video/mp4" />
          </video>
        )}

        <div className="hero-banner-content absolute inset-0 z-[2] flex h-full flex-col items-center justify-center px-4 text-center text-black md:-translate-y-[8%] md:px-8">
          <h1 className="max-w-[21rem] text-2xl font-bold leading-tight text-white min-[380px]:text-3xl md:max-w-4xl md:text-5xl">
            Get Amazing Indian Stock Videos
          </h1>
          <p className="mb-5 mt-2 text-xs font-light text-white min-[380px]:text-sm md:mb-8 md:mt-1 md:text-xl">
            Over 100+ videos added daily from all over India
          </p>

          <SearchInput variant="page" />
          <TrendingSearch className="mt-3 md:mt-4" limit={5} />

          <div className="hero-cta">
            {/* {!auth.role && (
              <button
                className="greenButton whitespace-nowrap"
                onClick={() => setShowSignUpModal(true)}
                aria-label="Explore Now - sign up for a free trial"
              >
                Explore Now
              </button>
            )} */}

            {!isSubscribed && (
              <Link
                to="/pricing"
                className="hero-pricing-link"
                aria-label="View pricing plans"
              >
                <button className="greenButton whitespace-nowrap">
                  Pricing
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>

      <Suspense fallback={null}>
        {showSignInModal && (
          <SignIn
            setShowModal={setShowSignInModal}
            switchToSignUp={() => {
              setShowSignInModal(false);
              setShowSignUpModal(true);
            }}
          />
        )}
        {showSignUpModal && (
          <SignUp
            setShowModal={setShowSignUpModal}
            switchToSignIn={() => {
              setShowSignUpModal(false);
              setShowSignInModal(true);
            }}
          />
        )}
      </Suspense>
    </section>
  );
};

export default Banner;
